/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PlanResponse1
 */
export interface PlanResponse1 {
    /**
     * Unique identifier for the plan
     * @type {string}
     * @memberof PlanResponse1
     */
    'id': string;
    /**
     * Display name of the plan
     * @type {string}
     * @memberof PlanResponse1
     */
    'name': string;
    /**
     * Formatted price string for display
     * @type {string}
     * @memberof PlanResponse1
     */
    'price': string;
    /**
     * Price amount in the smallest currency unit (e.g., won)
     * @type {string}
     * @memberof PlanResponse1
     */
    'amount': string;
    /**
     * Billing frequency
     * @type {string}
     * @memberof PlanResponse1
     */
    'billingCycle': PlanResponse1BillingCycleEnum;
    /**
     * Product code this plan belongs to
     * @type {string}
     * @memberof PlanResponse1
     */
    'productCode': string;
    /**
     * Specific plan code for backend plan lookup
     * @type {string}
     * @memberof PlanResponse1
     */
    'productPlanCode': string;
    /**
     * List of features included in this plan
     * @type {Array<string>}
     * @memberof PlanResponse1
     */
    'features': Array<string>;
    /**
     * Whether this plan supports recurring billing
     * @type {boolean}
     * @memberof PlanResponse1
     */
    'isBillingPlan': boolean;
    /**
     * Text to display on the action button
     * @type {string}
     * @memberof PlanResponse1
     */
    'actionText': string;
    /**
     * Whether this plan is recommended
     * @type {boolean}
     * @memberof PlanResponse1
     */
    'recommended'?: boolean;
}

export const PlanResponse1BillingCycleEnum = {
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    OneTime: 'ONE_TIME'
} as const;

export type PlanResponse1BillingCycleEnum = typeof PlanResponse1BillingCycleEnum[keyof typeof PlanResponse1BillingCycleEnum];


